export function gameSize(size: number): number {
  return size * 2;
}
